var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteGeometry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.987,
    height: 15,
    fill: "none",
    viewBox: "0 0 11.987 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 -1.5066 0)",
    style: {
      fill: "#000",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2252)",
    fill: "#f55",
    style: {
      fill: "#000",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.2589 9.3406c-0.48006 0.00264-0.93954 0.19523-1.278 0.53566-0.33848 0.34046-0.5284 0.80106-0.52827 1.2811v14.215c0 2.5259 2.064 4.6283 4.6021 4.6283h9.9477c2.5395 0 4.6282-2.0885 4.6282-4.6283v-14.215c2e-4 -0.48-0.1897-0.9406-0.5282-1.2811-0.3385-0.34043-0.798-0.53302-1.278-0.53566zm5.2827 5.4241c0.1493-2e-4 0.2971 0.0291 0.435 0.0862 0.1379 0.057 0.2632 0.1407 0.3687 0.2462s0.1892 0.2308 0.2463 0.3687c0.057 0.1379 0.0863 0.2858 0.0862 0.435v7.5131c1e-4 0.1492-0.0292 0.297-0.0862 0.4349-0.0571 0.1379-0.1408 0.2632-0.2463 0.3688-0.1055 0.1055-0.2308 0.1892-0.3687 0.2462s-0.2857 0.0863-0.435 0.0862c-0.1492 1e-4 -0.297-0.0292-0.4349-0.0862s-0.2632-0.1407-0.3687-0.2462c-0.1056-0.1056-0.1892-0.2309-0.2463-0.3688-0.057-0.1379-0.0863-0.2857-0.0862-0.4349v-7.5131c-1e-4 -0.1492 0.0292-0.2971 0.0862-0.435 0.0571-0.1379 0.1407-0.2632 0.2463-0.3687 0.1055-0.1055 0.2308-0.1892 0.3687-0.2462 0.1379-0.0571 0.2857-0.0864 0.4349-0.0862zm5.0367 0c0.1492-2e-4 0.297 0.0291 0.4349 0.0862 0.1379 0.057 0.2632 0.1407 0.3688 0.2462 0.1055 0.1055 0.1892 0.2308 0.2462 0.3687 0.0571 0.1379 0.0864 0.2858 0.0862 0.435v7.5131c2e-4 0.1492-0.0291 0.297-0.0862 0.4349-0.057 0.1379-0.1407 0.2632-0.2462 0.3688-0.1056 0.1055-0.2309 0.1892-0.3688 0.2462s-0.2857 0.0863-0.4349 0.0862c-0.1506 0.0022-0.3001-0.0255-0.4398-0.0816-0.1397-0.0562-0.2669-0.1395-0.3741-0.2452-0.1072-0.1058-0.1922-0.2318-0.2503-0.3707-0.058-0.139-0.0878-0.2881-0.0876-0.4386v-7.5131c-2e-4 -0.1506 0.0296-0.2997 0.0876-0.4386 0.0581-0.139 0.1431-0.265 0.2503-0.3707s0.2344-0.1891 0.3741-0.2452 0.2892-0.0839 0.4398-0.0816z",
    style: {
      fill: "#d40000",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6 0c-2.0106 0-3.6702 1.6575-3.6702 3.6702v1.712h-3.7801c-0.15102-1.7e-4 -0.30055 0.0298-0.43984 0.08815s-0.26553 0.14391-0.37134 0.25166c-0.10581 0.10776-0.18905 0.23555-0.24484 0.37588-0.0558 0.14033-0.08303 0.29039-0.0801 0.44138-1.4e-4 0.14924 0.02915 0.29704 0.0862 0.43494 0.05704 0.1379 0.14072 0.2632 0.24625 0.36873s0.23083 0.18921 0.36873 0.24626c0.1379 0.05704 0.28571 0.08633 0.43494 0.08619h4.8796c0.00691 0.00532 0.01389 0.01056 0.02093 0.01571 0.0088-0.00512 0.01753-0.01035 0.02619-0.01571h12.23c0.0087 0.00536 0.0174 0.01059 0.0263 0.01571 0.0034-0.00526 0.0069-0.0105 0.0104-0.01571h4.5079c0.1492 1.3e-4 0.297-0.02917 0.4349-0.08622s0.2632-0.14073 0.3687-0.24626c0.1055-0.10552 0.1892-0.23082 0.2462-0.36872 0.0571-0.1379 0.0864-0.28569 0.0862-0.43492 3e-3 -0.15099-0.0243-0.30105-0.0801-0.44138s-0.139-0.26812-0.2448-0.37588c-0.1058-0.10775-0.2321-0.19331-0.3714-0.25166s-0.2888-0.08832-0.4398-0.08815h-3.3822v-1.712c0-2.0106-1.6556-3.6702-3.6702-3.6702zm0 2.2618h7.2199c0.7959 0 1.3979 0.61709 1.3979 1.4084v1.712h-10.016v-1.712c0-0.79592 0.6066-1.4084 1.3979-1.4084z",
    style: {
      fill: "#d40000",
      strokeWidth: 3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteGeometry);
export default __webpack_public_path__ + "static/media/icon_delete_geometry.f5d7339000491dc98d045cf54e2d0240.svg";
export { ForwardRef as ReactComponent };